import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

export default function ViewServiceWork({ services }) {

    if (typeof services === 'string') services = JSON.parse(services)
    return (
        <TableContainer component='div' >
            <Table sx={{ minWidth: 650 }} size='small' aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align='center'><b>Concepto</b></TableCell>
                        <TableCell align="center"><b>Unidad</b></TableCell>
                        <TableCell align="center"><b>Cantidad</b></TableCell>
                        <TableCell align='center'><b>Precio/día x ud</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {services.map(fields => (
                        <TableRow key={fields.id}>
                            <TableCell align='center'>{fields.product}</TableCell>
                            <TableCell align="center">{fields.measure}</TableCell>
                            <TableCell align="center">{fields.amount}</TableCell>
                            <TableCell align='center'>{fields.priceProduct}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

        // <Stack width='100%' >
        //     {services.map(s => (
        //         <Stack key={s.id} direction='row' justifyContent='space-between' width='100%'>
        //             <Typography variant='subtitle1'><b>Concepto: </b> {s.product}</Typography>
        //             <Typography variant='subtitle1'><b>Unidad: </b> {s.measure}</Typography>
        //             <Typography variant='subtitle1'><b>Cantidad: </b> {s.amount}</Typography>
        //             <Typography variant='subtitle1'><b>Precio/unidad: </b> {s.priceProduct}€</Typography>
        //         </Stack>
        //     ))}
        // </Stack>